module.exports = __webpack_public_path__ + "static/media/restart_alt_white.4294dbff.svg";